import MainLayout from '@/layouts/MainLayout.vue'
import { Cache } from '@/services/cache';
import { useAuthStore } from '@/stores/auth';
import { action } from '@/utils';
import { KTComponent } from 'metronics-vue';
import { VueElement } from 'vue';
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: MainLayout,
      meta: { requiresAuth: true , breadcrumb: 'Dashboard' },
      children: [
        { path: '', name: 'dashboard', component: () => import('@/pages/dashboard/DashboardPage.vue'),   meta: { breadcrumb: 'Dashboard' }},
        //User Management Routes
        { path: '/user-management', name: 'User Management', component: () => import('@/pages/agents/AgentsIndexPage.vue'), meta: { breadcrumb: 'User Management' } },
        { path: '/user-management/agent-profile/:agent_id', name: 'Profile Viewing', component: () => import('@/pages/agents/components/ViewAgentsProfilePage.vue'),  meta: { breadcrumb: [
          { label: 'Profile Viewing' }
        ] }},
        //Policy Template Management Routes
        { path: '/policy-management', name: 'policy-management', component: () => import('@/pages/policies/PolicyIndexPage.vue'), meta: { breadcrumb: 'Policies' } },
        //Client Management Routes
        { path: '/client-management', name: 'client-management', component: () => import('@/pages/clients/ClientsIndexPage.vue'), meta: { breadcrumb: 'Client Management' }, },
        { 
          path: '/client-management/:client_id', 
          name: 'client-view', 
          component: () => import('@/pages/clients/components/ViewClient.vue'),  
          meta: { 
            breadcrumb: [
              { label: 'Client Management', to: '/client-management' },
              { label: 'View Client' }
            ]
          }
        },
        { 
          path: '/client-requirements', 
          name: 'client-requirements', 
          component: () => import('@/pages/requirements/RequirementsIndexPage.vue'),
          meta: { 
            breadcrumb: [
              { label: 'Client Management', to: '/client-management' },
              { label: 'Requirements' }
            ]
          }
        },
        { 
          path: '/client-payments', 
          name: 'client-payments', 
          component: () => import('@/pages/policy-payment/PolicyPaymentIndexPage.vue'),
          meta: { 
            breadcrumb: [
              { label: 'Client Management', to: '/client-management' },
              { label: 'Policy Payments' }
            ]
          }
        },
        { 
          path: '/client-payments/:client_id', 
          name: 'client-payments-view', 
          component: () => import('@/pages/policy-payment/components/ViewClientPayments.vue'),  
          meta: { 
            breadcrumb: [
              { label: 'Client Management', to: '/client-management' },
              { label: 'Policy Payments', to: '/client-payments' },
              { label: 'Payments' }
            ]
          }
        },
        { path: '/user-management', name: 'user-management', component: () => import('@/pages/agents/AgentsIndexPage.vue') },
        { path: '/user-management/agent-profile/:agent_id', name: 'agent-profile', component: () => import('@/pages/agents/components/ViewAgentsProfilePage.vue') },

        //Agency Management Routes
        { path: '/agency-management', name: 'agency-management', component: () => import('@/pages/agency/AgencyIndexPage.vue'), meta: { breadcrumb: 'Agency Management' }, },
        { path: '/agency-management/profile/:agency_id', name: 'agency-profile', component: () => import('@/pages/agency/components/ViewAgencyProfileIndexPage.vue'), meta: { breadcrumb: 'Agency Profile View' }},
        { path: '/agency-management/agent-profile/:agent_id', name: 'View Agent Profile', component: () => import('@/pages/agents/components/ViewAgentsProfilePage.vue'),  meta: { breadcrumb: [
          { label: 'Agency Management', to: '/agency-management' },
          { label: 'View Agent Profile' }
        ] }},
        //Commission and Incentive Management Routes
        { path: '/commission-incentives/payment-tracking', name: 'Payment Tracking', component: () => import('@/pages/payment-tracking/PaymentTrackingIndexPage.vue'), meta: { breadcrumb: 'Payment Tracking' }, },
        { path: '/commission-incentives/payment-tracking/client-overview/:id', name: 'Client Payment Overview', component: () => import('@/pages/payment-tracking/components/ClientPaymentTrackingOverview.vue'), 
          meta: { breadcrumb: [
            { label: 'Payment Tracking', to: '/commission-incentives/payment-tracking' },
            { label: 'Client Payment Overview' }
          ] }, 
        },
        { path: '/commission-incentives/commission-statements', name: 'commission-statements', component: () => import('@/pages/commission-statement/CommissionStatementsIndexPage.vue'), meta: { breadcrumb: 'Commission Statements' }, },
        { path: '/commission-incentives/commission-statements/agency/:id', name: 'view-commission-statement', component: () => import('@/pages/commission-statement/components/ViewAgencyCommissionPaymentHistoryLogs.vue'), meta: { breadcrumb: 'View Commission Statement' }, },
        //Sales and Performance Tracking Routes
        { path: '/sales-performance/sales-report', name: 'sales-report', component: () => import('@/pages/sales-report/SalesReportIndexPage.vue'), meta: { breadcrumb: 'Sales Report' }, },
        { path: '/sales-performance/incentive-calculation', name: 'incentive-calculation', component: () => import('@/pages/incentives-calculation/IncentivesCalculationIndexPage.vue'), meta: { breadcrumb: 'Incentive Calculation' }, },
        { path: '/reports', name: 'reports', component: () => import('@/pages/reports/ReportsIndex.vue'), meta: { breadcrumb: 'Reports' }, },
      ]
    },
    { path: '/login', name: 'login', component: () => import('@/pages/AmsLogin.vue') },
  ],
})

router.beforeEach(async(to, from, next) => {
  const store = useAuthStore()

  if (to.meta.requiresAuth) {
    if (store.user === null) {
      const [_, error] = await action(() => store.fetchUser());
      if (error) {
        return next('/login');
      }
    }

  }  
	KTComponent.init();
  next()
});



export default router
